import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";
import Icon from "../selfcare/Icon.tsx";
import {formatAmount, formatAmountWithCurrency, formatAmountWithCurrencyOverPeriod} from "../../util/formatter.ts";
import PhoneNumberSpanComponent from "../callMe/PhoneNumberSpanComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import IconArrow from "../icons/IconArrow.tsx";

const oprettelse = 398;
const tilslutning = 699;
const _default = 299;
const default_max = 339;

const kampagne = 99;
const tid = 6;
const rabat = tid * (default_max - kampagne);

const total = oprettelse + tilslutning + rabat;
const min_6 = 6 * kampagne;
const end = '30.06.25';

const phone = '92900030';

export default function TilbudHeroComponent() {
    return (
        <>
            <div id="hero-container" className="hero-container hero-container--tilbud-1">
                <div className="hero-background-wrapper">
                    <div className="hero-background"></div>
                </div>
                <div className="hero-content">
                    <div className="stamp">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                            <circle
                                fill="none"
                                stroke="#303a4b"
                                strokeWidth="15px"
                                strokeDasharray="1 40.5"
                                strokeLinecap="round"
                                cx="512"
                                cy="512"
                                r="462"
                            />
                        </svg>
                        <h1>
                            <span className="pre-1">Få <strong>1000 Mbit</strong></span>
                            <span className="pre-2">fibernet til kun</span>
                            <span className="price">
                                <span className="hiper-text-stroke">{kampagne}</span><span className="comma-dash">,-</span><span className="md">/md.</span>
                            </span>
                            <span className="post">De første {tid} mdr.</span>
                        </h1>
                    </div>
                    <h2>
                        <span className="header-main">Der er fiber på din adresse</span>
                        <span className="header-sub">Aktivér dit TDC NET fiber nu &ndash; <strong>til 0 kr.</strong>
                            <span className="hide-on-small-devices">
                                <br/>Det er nemlig allerede klar på din adresse.
                            </span>
                        </span>
                    </h2>
                </div>
            </div>

            <div className="hero-container hero-container--tilbud-2">
                <div className="total-discount-container">
                    <div className="total-discount">
                        <h3 className="heading heading--small heading--left">
                            <span className="hide-on-small-devices">Så meget sparer du</span>
                            <span className="hide-on-large-devices">Spar op til</span>
                        </h3>
                        <table>
                            <tbody>
                            <tr>
                                <td>Oprettelse</td>
                                <td>{formatAmountWithCurrency(oprettelse)}</td>
                            </tr>
                            <tr>
                                <td>Tilslutning</td>
                                <td>{formatAmountWithCurrency(tilslutning)}</td>
                            </tr>
                            <tr>
                                <td>Kampagnerabat i {tid}&nbsp;mdr.</td>
                                <td>{formatAmountWithCurrency(rabat)}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td><strong>I alt<span className="hide-on-small-devices"> op til</span></strong></td>
                                <td><strong>{formatAmountWithCurrency(total)}</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="stamp-container">
                        <span className="equals">=</span>
                        <div className="stamp">
                            <p>
                                Spar op til<br/>
                                <strong>{formatAmount(total, false)}<span className="comma-dash">,-</span></strong>
                            </p>
                        </div>
                    </div>
                    <div className="cta-container">
                        <Icon component={IconArrow}/>
                        <p>
                            Bestil <strong>
                            <button className={"link"} onClick={() => DispatchHighLightAddressSearchEvent(true)}>her</button>
                        </strong><br/>
                            Eller ring på<br/>
                            <strong><a href={`tel:+45` + phone}>
                                <PhoneNumberSpanComponent phoneNo={phone}/>
                            </a></strong>
                        </p>
                    </div>
                </div>
                <div className="address-wrap">
                    <h2>Indtast adresse<div className="scroll-down-arrow"></div></h2>
                    <OrderAddressSearchComponent/>
                </div>
                <p className="conditions">
                    Tilbuddet gælder de første {tid} mdr. og er inkl. gratis oprettelse, tekniker, tilslutning og wifi-router.
                    Min. pris i 6 mdr. {formatAmountWithCurrency(min_6)} Pris efter {tid} mdr. fra {formatAmountWithCurrencyOverPeriod(_default)} Tilbuddet er kun fiber via TDC Nets netværk.
                    Gælder udvalgte adresser t.o.m. {end}.
                </p>
            </div>
        </>
    )
}
